import React from 'react';
import { cx } from '../cx';

// D-09 §15.20 — Breadcrumb (.crumb > a · .sep · .cur)
export interface Crumb {
  label: string;
  href?: string;
}
export interface BreadcrumbProps extends React.HTMLAttributes<HTMLDivElement> {
  items: Crumb[];
}

export function Breadcrumb({ items, className = '', ...props }: BreadcrumbProps) {
  return (
    <div className={cx('crumb', className)} {...props}>
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <React.Fragment key={i}>
            {i > 0 && <span className="sep">/</span>}
            {last || !it.href ? (
              <span className="cur">{it.label}</span>
            ) : (
              <a href={it.href}>{it.label}</a>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
